<div class="ws-filter-container" [ngStyle]="{ 'max-height': maxHeight }">
    <div class="d-flex w-100">
        <select class="form-select form-select-sm"
                [ngModel]="filterValues[0].filterType"
                (ngModelChange)="setFilterType($event)">
            @for (option of selectFilterOptions; track option) {
                <option [ngValue]="option">{{ option.displayName }}</option>
            }
        </select>
        <div class="condition d-flex">
            <button class="ace-btn btn-sm btn-secondary"
                    [class.active]="filterConditionType === 1"
                    (click)="setConditionType(1)">And
            </button>
            <button class="ace-btn btn-sm btn-secondary"
                    [class.active]="filterConditionType === 2"
                    (click)="setConditionType(2)">Or
            </button>
        </div>
    </div>
    @for (filter of filterValues; track trackByFn(i); let isFirst = $first; let isLast = $last; let i = $index) {
        @if (filterConditionType !== 0 && !isFirst) {
            <div class="condition-filter-type d-flex">
                <select class="form-select form-select-sm" [(ngModel)]="filter.filterType">
                    @for (option of selectFilterOptions; track option) {
                        <option [ngValue]="option">{{ option.displayName }}</option>
                    }
                </select>
                <button class="ace-btn has-icon btn-primary btn-danger btn-sm"
                        helpTooltip
                        helpContentId="ag-grid.removeFilter"
                        position="right"
                        (click)="removeFilterValue(i)">
                    <i class="fa fa-minus"></i>
                </button>
                @if (filter.filterType && !filter.filterType.numberOfInputs) {
                    <button
                        class="ace-btn has-icon btn-primary btn-sm"
                        helpTooltip
                        helpContentId="ag-grid.addFilter"
                        position="right"
                        (click)="addFilterValue()">
                        <i class="fa fa-plus"></i>
                    </button>
                }
            </div>
        }
        @if (!(filter.filterType && !filter.filterType.numberOfInputs)) {
            <div class="d-flex">
                <div class="text-input d-flex">
                    <input type="text"
                           (ngModelChange)="onChange($event, i)"
                           [ngModel]="filter.filterValue"
                           class="form-control"
                           [class.has-reset]="filter.filterValue"
                    />
                    <span class="reset-value clickable"
                          [class.showReset]="filter.filterValue"
                          helpTooltip
                          helpContentId="ag-grid.clearField"
                          position="right"
                          (click)="clearInput(i)">
                        <i class="fa fa-times"></i>
                    </span>
                </div>
                @if (filterConditionType !== 0 && isLast) {
                    <button
                        class="ace-btn has-icon btn-primary btn-sm"
                        helpTooltip
                        helpContentId="ag-grid.addFilter"
                        position="right"
                        [disabled]="!filter.filterValue"
                        (click)="addFilterValue()">
                        <i class="fa fa-plus"></i>
                    </button>
                }
            </div>
        }
    }
    <div class="d-flex condition-filter-type">
        <button #applyButton
                class="ace-btn btn-primary btn-sm w-100"
                helpTooltip
                helpContentId="ag-grid.applyFilter"
                position="bottom"
                (click)="applyFilter()">Apply
        </button>
        <button class="ace-btn has-icon btn-primary btn-danger btn-sm"
                helpTooltip
                helpContentId="ag-grid.clearFilterHelpContentId"
                position="bottom"
                (click)="clearFilter()">
            <i class="fa fa-times"></i>
        </button>
    </div>
</div>
